import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";

import { useCreateProjectMutation } from "../../services/projectService";
import { Form } from "../../components/forms";
import Button from "../../components/Button/Button";
import TextField from "../../components/forms/TextField";
import { logEvent } from "../../utils/amplitudeUtlis";

export default function CreateSupplyChainTraceabilityProject() {
    const [createProject] = useCreateProjectMutation();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage] = useState(null);
    const navigate = useNavigate();

    const handleAddProjectSubmit = async (values) => {
        setIsLoading(true);
        const projectName = values.projectTitle;
        try {
            const addProjectRes = await createProject({
                name: projectName,
                template: "SUPPLY_CHAIN",
            });

            if (addProjectRes.data) {
                setIsLoading(true);
                toast.success("Project created");
                navigate(`/overview`);
                logEvent({
                    eventName: "project_creation_completed",
                    eventProperties: {
                        project_name: projectName,
                        project_id: addProjectRes?.data?.data?.id,
                        template: "SUPPLY_CHAIN",
                    },
                });
            } else {
                if (addProjectRes.error.data?.errors[0].template) {
                    toast.error(addProjectRes.error.data?.errors[0].template[0]);
                    logEvent({
                        eventName: "project_creation_failed",
                        eventProperties: {
                            errorMessage:
                                addProjectRes.error.data?.errors[0].template[0],
                        },
                    });
                } else {
                    toast(
                        addProjectRes.error.data?.errors[0].name ||
                            addProjectRes.error.data.errors[0],
                    );
                    logEvent({
                        eventName: "project_creation_failed",
                        eventProperties: {
                            errorMessage:
                                addProjectRes.error.data?.errors[0].name ||
                                addProjectRes.error.data.errors[0],
                        },
                    });
                }
            }
            setIsLoading(false);
        } catch (error) {
            console.log(error);
        }
    };

    const validationSchema = yup.object({
        projectTitle: yup
            .string()
            .required("Project title is required")
            .min(2, "Project title should be of minimum 2 characters length")
            .max(50, "Project title should be of maximum 50 characters length")
            .trim("Project title must not be empty or just spaces")
            .required("Project title must not be empty or just spaces"),
    });

    return (
        <div className="create-project-container">
            <Form
                initialValues={{
                    projectTitle: "",
                    noOfToken: "",
                    totalFundingAmount: "",
                }}
                onSubmit={handleAddProjectSubmit}
                enableReinitialize={true}
                validationSchema={validationSchema}
            >
                <div className="form-group">
                    <TextField
                        name="projectTitle"
                        label="Project title"
                        className="form-control"
                    />
                </div>

                <div className="form-group mt-5 d-flex justify-content-end">
                    <Button
                        type="button"
                        variant="secondary"
                        onClick={() => navigate("/overview")}
                        fullWidth={false}
                        className="me-2"
                    >
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary" fullWidth={false}>
                        {isLoading ? "Loading..." : "Continue"}
                    </Button>
                </div>
                {errorMessage && (
                    <div className="error-message">{errorMessage}</div>
                )}
            </Form>
        </div>
    );
}
